import type { InjectionKey } from 'vue';
import type { CreateToasterReturn } from '@ark-ui/vue/toast';

export const i18nInjectionKey = Symbol('i18n');

export const languageInjectionKey = Symbol('language');

export const communityInjectionKey = Symbol('community');

export const tokenInjectionKey = Symbol('token');

export const storeInjectionKey = Symbol('store');

export const userAgentInjectionKey = Symbol('userAgent');

export const toastInjectionKey = Symbol('toast') as InjectionKey<CreateToasterReturn>;
